import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import { useFormContext } from 'react-hook-form-mui';
import DataContainer from '../../../../Utilities/DataContainer';
import RenderSelectField from '../../../../Utilities/Forms/RenderSelectField';
import RenderTextField from '../../../../Utilities/Forms/RenderTextField';
import yesNoDropdown from '../../../../Utilities/Constants/YesNoDropdown';
import TravelPlanV1ViewModel from '../../../ViewModels/TravelPlan/TravelPlanV1ViewModel';

interface IProps {
    isReadOnly: boolean
}
export default function TravelPlanSiteChangesV1({ isReadOnly }: IProps) {

    const { getValues } = useFormContext<TravelPlanV1ViewModel>();
    const formValues = getValues();
    const hasValues = (fields: string[]) => fields.some(field => formValues[field]) || !isReadOnly;

    return (
        <>
            <Grid size={12}>
                <Typography variant="h6">Changes in Site Environment and Circumstances</Typography>
            </Grid>
            <Grid size={12}>
                <Typography variant="body1">Since the travel plan was implemented, have any of the following changes occurred?</Typography>
            </Grid>
            <Grid container alignItems="flex-start">
                <Grid size={4} container>
                    {hasValues(["largeScaleChangeInStaffNumbers"]) && (
                        <Grid container size={12}>
                            <RenderSelectField name="largeScaleChangeInStaffNumbers" label="Has there been large scale changes in numbers of staff on site?" readOnly={isReadOnly} options={yesNoDropdown} />
                        </Grid>
                    )}
                    {hasValues(["changeInSiteFunction"]) && (
                        <Grid container size={12}>
                            <RenderSelectField name="changeInSiteFunction" label="Has there been a change in site function from, for example, call centre to head office; or from administrative to sales, etc?" readOnly={isReadOnly} options={yesNoDropdown} />
                        </Grid>
                    )}
                </Grid>

                <Grid size={4} container>
                    {hasValues(["parkingControlsChanged"]) && (
                        <Grid container size={12}>
                            <RenderSelectField name="parkingControlsChanged" label="Have parking controls been implemented around a site where previously many staff parked at no charge?" readOnly={isReadOnly} options={yesNoDropdown} />
                        </Grid>
                    )}
                    {hasValues(["largeScaledChangesInPublicTransportServices"]) && (
                        <Grid container size={12}>
                            <RenderSelectField name="largeScaledChangesInPublicTransportServices" label="Has there been large scale changes in local public transport services?" readOnly={isReadOnly} options={yesNoDropdown} />
                        </Grid>
                    )}
                    {formValues.largeScaledChangesInPublicTransportServices === 'Y' &&
                        <Grid container size={12}>
                            <RenderTextField name="largeScaledChangesInPublicTransportServicesComment" label="" readOnly={isReadOnly} multiLine={true} rows={4} inputSize={12} labelSize={12} alwaysShow={true} />
                        </Grid>

                    }


                    {hasValues(["siteRelocatedToPlaceWithDifferingAccessiility"]) && (
                        <Grid container size={12}>
                            <RenderSelectField name="siteRelocatedToPlaceWithDifferingAccessiility" label="Has the site been relocated to somewhere with different accessibility characteristics (e.g from city centre to edge of town)?" readOnly={isReadOnly} options={yesNoDropdown} />
                        </Grid>
                    )}
                </Grid>

                <Grid size={4} container>
                    <Grid container size={12}>
                        <RenderTextField name="detailsOfFactorsAffectingTripRates" label="Factors that may have affected trip rates." readOnly={isReadOnly} multiLine={true} rows={4} inputSize={12} labelSize={12} alwaysShow={true} />
                    </Grid>
                    <Grid container size={12}>
                        <Grid size={12}>
                            <DataContainer title="Additional Comments">
                                <Grid size={12}>
                                    <RenderTextField label="Additional comments on the Travel Plan which are not covered elsewhere in this section" name="additionalCommentsOnTravelPlan" readOnly={isReadOnly} multiLine={true} rows={4} inputSize={12} labelSize={12} alwaysShow={true} />
                                </Grid>
                            </DataContainer>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
}
